const FormMode = {
    READING: 0,
    CREATING: 1,
    EDITING: 2
}
export default FormMode;